<div class="grey-title">
  <span>&nbsp;</span>
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (existingDisciplines.length > 0) {
    <div class="existing-disciplines">
      <p><strong>Disciplines with existing templates:</strong></p>
      <mat-chip-set>
        @for (d of existingDisciplines; track d) {
          <mat-chip>{{ d.disciplineNumber }} - {{ d.disciplineName }}</mat-chip>
        }
      </mat-chip-set>
    </div>
  }

  <mat-form-field appearance="fill" class="discipline-select">
    <mat-label>Select Discipline</mat-label>
    <mat-select [(value)]="selectedDiscipline">
      @for (discipline of disciplines$ | async; track discipline) {
        <mat-option [value]="discipline">{{ discipline.disciplineNumber }} - {{ discipline.disciplineName }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()" class="cancel-button">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="!selectedDiscipline" (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
